import React from 'react';
import sideoLogo from '../assets/brand/Sideo_Logo_N.svg';

const BrandLogo = ({ className = 'h-8 w-auto', alt = 'Sideo' }) => {
  return <img src={sideoLogo} alt={alt} className={className} />;
};

export default BrandLogo;